<template>
  <div class="app">
    <el-card class="box-card">
      <!-- 查询 -->
      <div class="header-item query">
        <el-select v-model="queryDb.storeId" slot="prepend" placeholder="請選擇门店" style="margin-right: 12px">
          <el-option
            v-for="item in storeList"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="queryDb.time"
          type="month"
          placeholder="选择月"
          style="margin-right: 12px">
        </el-date-picker>
        <!-- <el-button type="primary" @click="queryBin" :loading="loading">查詢</el-button> -->
      </div>
      <!-- 日历 -->
      <el-calendar  :first-day-of-week="7"
        v-model="time"
        :loading="calendarLoading"
        id="calendar">
        <template
          slot="dateCell"
          slot-scope="{date, data}">
          <div >
            <div class="calendar-day">
              <span v-if="data.day.split('-').slice(1)[0] == time.split('-').slice(1)[0]">
                <h1>{{ data.day.split('-').slice(2).join('-') }}</h1>
              </span>
              <span v-else>
                <h1>{{ data.day.split('-').slice(2).join('-') }}</h1>
              </span>
            </div>
            <div v-if="data.day.split('-').slice(1)[0] == time.split('-').slice(1)[0]">

              <!--              <div v-for="item in calendarData" v-if="calendarData.length > 0">-->
              <!--                <div v-if="item.months && (item.months).indexOf(data.day.split('-').slice(1)[0])!=-1">-->
              <!--                  <div v-if="item.days && (item.days).indexOf(data.day.split('-').slice(2).join('-'))!=-1" class="is-selected">-->
              <!--                    <el-button size="mini" type="danger" disabled>{{item.things}}</el-button>-->
              <!--                  </div>-->
              <!--                  <div v-else class="is-selected">-->
              <!--                    <el-button size="mini" type="success" @click.stop="bookingTimeList(data.day.split('-').slice(2).join('-'))">可預約</el-button>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->

              <div class="is-selected">
                <el-button size="mini" type="primary" @click.stop="bookingTimeList(data.day.split('-').slice(2).join('-'))">查看坐席</el-button>
              </div>

            </div>
          </div>
        </template>
      </el-calendar>
    </el-card>


    <!-- 查阅预约时间 -->
    <el-dialog
      :title="'查詢日期：'+seatTimeData.date+' | 門市：'+getStoreName(queryDb.storeId)"
      :visible.sync="bookingTimeStatus"
      width="800px"
      :before-close="bookingTimeClose">
      <el-row>
        <el-col class="seat-col " :md="6" v-for="(item,index) in seatTimeData.list" :key="index">
          <el-col :md="12">
            <div class="title">{{item.time}}</div>
            <div :class="{'text color-danger':item.count==0,'text color-success':item.count>0}">
              {{item.count?'剩餘 '+item.count+' 坐席':'已預約滿'}}
            </div>
          </el-col>
          <el-col :md="12">

            <div class="setAtHisTable" v-if="$atk.in_array(queryDb.storeId,myStoreId)">
              <el-tooltip content="還原此佔用時間段" placement="right">
                <div class="el-icon-refresh-left setAtHisTableRefresh" @click="refreshVirtualSeat(seatTimeData.date,item.time,queryDb.storeId)"></div>
              </el-tooltip>

              <el-tooltip content="佔用此時間段" placement="top">
              <el-button size="mini"
                         :type="item.count<=1?'danger':'success'"
                         icon="el-icon-user-solid"
                         style="padding: 2px;"
                         :disabled="item.count<=1?true:false"
                         @click="setManualAttendStatus(seatTimeData.date,item.time,queryDb.storeId)"></el-button>
              </el-tooltip>
              <el-tooltip content="佔用此時間段" placement="top">
              <el-button size="mini"
                         :type="item.count<=0?'danger':'success'"
                         icon="el-icon-user-solid"
                         style="padding: 2px;"
                         :disabled="item.count<=0?true:false"
                         @click="setManualAttendStatus(seatTimeData.date,item.time,queryDb.storeId)"></el-button>
              </el-tooltip>
            </div>
            <div class="setAtHisTable" v-else>
              沒有设置權限!
            </div>
          </el-col>

        </el-col>
      </el-row>
    </el-dialog>

  </div>
</template>
<script>
import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo
      })
    },
    name: "calendar",
    data() {
      return {
        queryDb:{
          storeId:1,
          time:'',
        },
        time:'',
        storeList:[],
        seatTimeData:{
          list:[],
          date:'',
        },
        myStoreId:0,
        bookingTimeBtnKey:0,
        bookingTimeStatus:false,
        loading:false,
        calendarLoading:false,
        calendarData: [
          // {
          //   months: '10',
          //   days: ['01','02','03','04'],
          //   things: '已約满'
          // },
        ],
      }
    },
    mounted() {
      let that = this
      that.getStoreList()
      that.queryDb.time = that.$atk.date_format()
    },
    methods:{
      // 還原虛擬坐席
      refreshVirtualSeat(date, time, storeId){
        var that = this
        if(!date){
          that.$message({
            message: "查詢日期不能留空！",
            type: "warning",
          });
          return
        } else if(!time){
          that.$message({
            message: "查詢時間段不能留空！",
            type: "warning",
          });
          return
        } else if(!storeId){
          that.$message({
            message: "查詢門市不能留空！",
            type: "warning",
          });
          return
        }
        that.$confirm("您确认要還原此("+time+")預約時間段吗?", "還原提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var data={
            dates:date,
            times:time,
            storeId:storeId
          }
          that.$http.POST("/v1/booking/restoreVirtualSeat",data, (ret)=> {
              that.calendarLoading = false
              if (ret.errcode == 0) {
                //that.deleteItem(time, that.seatTimeData.list);
                that.bookingTimeList(that.bookingTimeBtnKey)
              } else if (ret.errcode >= 1) {
                that.$message({
                  message: ret.errmsg,
                  type: "warning",
                });
              }
            }, (err)=> {
              that.calendarLoading = false
              that.$notify({
                title: "警告",
                message: err,
                type: "warning",
              });
            }
          );

        }).catch(() => {
          that.$notify({
            title: "還原提示",
            message: "已取消還原時間段",
            type: "warning",
          });
        });
      },
      // 設置坐席佔位
      setManualAttendStatus(date, time, storeId){
        var that = this
        if(!date){
          that.$message({
            message: "查詢日期不能留空！",
            type: "warning",
          });
          return
        } else if(!time){
          that.$message({
            message: "查詢時間段不能留空！",
            type: "warning",
          });
          return
        } else if(!storeId){
          that.$message({
            message: "查詢門市不能留空！",
            type: "warning",
          });
          return
        }
        that.$confirm("您确认要佔用此("+time+")預約時間段吗?", "佔用提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var data={
            dates:date,
            times:time,
            storeId:storeId
          }
          // console.log(data)
          that.$http.POST("/v1/booking/setManualAttendStatus",data, (ret)=> {
              that.calendarLoading = false
              if (ret.errcode == 0) {
                that.deleteItem(time, that.seatTimeData.list);
              } else if (ret.errcode >= 1) {
                that.$message({
                  message: ret.errmsg,
                  type: "warning",
                });
              }
            }, (err)=> {
              that.calendarLoading = false
              that.$notify({
                title: "警告",
                message: err,
                type: "warning",
              });
            }
          );

        }).catch(() => {
            that.$notify({
              title: "佔用提示",
              message: "已取消佔用時間段",
              type: "warning",
            });
          });
      },
      // 删除時間段
      deleteItem(time, list) {
        for (let key in this.seatTimeData.list) {
          if (list[key].time === time) {
            list[key].count = list[key].count - 1
          }
        }
      },
      getStoreName(storeId = 0){
        var list = this.storeList
        //console.log(list)
        for(var o in list){
          if(list[o].id == storeId){
            return list[o].label
          }
        }
        return ""
      },
      // 預約時間列表按鈕
      bookingTimeList(key = '01'){
        let that = this
        that.bookingTimeBtnKey = key
        let timeDb = that.time.split('-')
        let dateDb = timeDb[0]+'-'+timeDb[1]+'-'+key
        let param = that.$atk.json_to_url({
          dates: dateDb,
          storeId:that.queryDb.storeId
        });
        that.calendarLoading = true
        that.$http.GET("/v1/booking/getSeatInfo?"+param, (ret)=> {
            that.calendarLoading = false
            if (ret.errcode == 0) {
              that.seatTimeData.list = ret.data
              that.seatTimeData.date = dateDb
              that.bookingTimeStatus = true
            } else if (ret.errcode >= 1) {
              that.$message({
                message: ret.errmsg,
                type: "warning",
              });
            }
          }, (err)=> {
            that.calendarLoading = false
            that.$notify({
              title: "警告",
              message: err,
              type: "warning",
            });
          }
        );
      },
      //处理时间
      handleTime(s) {
        return s < 10 ? '0' + s : s
      },
      bookingTimeClose(close){
        close()
      },
      // 查詢按鈕
      queryBin(){
        this.loading = true
      },
      // 获取門店列表
      getStoreList() {
        let that = this;
        this.$http.GET(
          "/v1/booking/getStoreList?w=1",
          function (ret) {
            if (ret.errcode == 0) {
              let list = ret.data.list
              that.myStoreId = ret.data.storeId
              for(let i in list){
                if(that.$atk.in_array(list[i].id,ret.data.storeId)){
                  that.storeList.push({
                    id:list[i].id,
                    value:list[i].id,
                    label:list[i].title,
                  })
                }
              }
            } else if (ret.errcode >= 1) {
              that.$message({
                message: ret.errmsg,
                type: "warning",
              });
            }
          },
          function (err) {
            that.$notify({
              title: "警告",
              message: err,
              type: "warning",
            });
          }
        );
      }
    },
    watch:{
      'queryDb.time':function () {
        this.time = this.$atk.formatDate(this.queryDb.time)
      }
    },
    // created(){
    //   let that = this
    //   that.$nextTick(() => {
    //     // 点击前一个月
    //     let prevBtn = document.querySelector(
    //       ".el-calendar__button-group .el-button-group>button:nth-child(1)"
    //     );
    //     prevBtn.addEventListener("click", e => {
    //       let d = new Date(that.value);
    //       let resDate = d.getFullYear() + '-' + that.handleTime((d.getMonth() + 1));
    //       console.log('点击前一个月',resDate)
    //     })
    //     //点击下一个月
    //     let nextBtn = document.querySelector(
    //       ".el-calendar__button-group .el-button-group>button:nth-child(3)"
    //     );
    //     nextBtn.addEventListener("click", e => {
    //       let d = new Date(that.value);
    //       let resDate = d.getFullYear() + '-' + that.handleTime((d.getMonth() + 1));
    //       console.log('点击下一个月',resDate)
    //     })
    //     //点击今天
    //     let todayBtn = document.querySelector(
    //       ".el-calendar__button-group .el-button-group>button:nth-child(2)"
    //     );
    //     todayBtn.addEventListener("click", e => {
    //       let d = new Date(that.value);
    //       let resDate = d.getFullYear() + '-' + that.handleTime((d.getMonth() + 1));
    //       console.log('点击今天',resDate)
    //     })
    //   });
    // }
  }
</script>
<style>
  .el-calendar__header .el-calendar__button-group{
    display: none;
  }
  .el-calendar-table td.is-selected {
    background-color: #e9e36f;
  }
  .el-backtop, .el-calendar-table td.is-today {
    color: #050505;
  }
</style>
<style scoped lang="scss">
  .calendar-day{
    text-align: center;
    line-height: 10px;
    font-size: 12px;
  }
  .is-selected{
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
  }
  #calendar .el-button-group>.el-button:not(:first-child):not(:last-child):after{
    content: '当月';
  }

  .seat-col{
    height: 55px;
    padding: 6px;
    text-align: center;
    border: 1px solid #EBEEF5;
    .title{
      font-size: 16px;
      font-weight: 900;
    }
    .text{
      position: relative;
      font-size: 12px;
    }

    .setAtHisTable{
      position: relative;
      padding-top: 15px;
      .setAtHisTableRefresh{
        position:absolute;
        color: #e4951e;
        right: -3px;
        top:-3px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
</style>
